import { render, staticRenderFns } from "./v-logo.vue?vue&type=template&id=51a4e223&scoped=true"
import script from "./v-logo.vue?vue&type=script&lang=ts"
export * from "./v-logo.vue?vue&type=script&lang=ts"
import style0 from "./v-logo.vue?vue&type=style&index=0&id=51a4e223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a4e223",
  null
  
)

export default component.exports